<!--
// app/components/Shared/HeaderBannerTitle.vue
-->
<script setup lang="ts">
import { useRegions } from "~/composables/regions";

type Props = {
  title: string;
};

defineProps<Props>();

const { isMena } = useRegions();
</script>

<template>
  <div class="kql-w-container flex items-center justify-between px-4 xl:px-2 py-6">
    <h1
      :class="[
        'text-primary uppercase text-5xl md:text-7xl font-kings rtl:font-bold',
        { '!leading-normal': isMena },
      ]"
    >
      {{ title }}
    </h1>
  </div>
</template>

<style scoped></style>
